module.exports = __webpack_public_path__ + "static/media/20210109_202611_703_IMG_1657.037b7921.jpg";